import { Modal } from "@mui/material";
import styled from "styled-components";

export const Container = styled.div`
	width: 100%;
	margin: 0 auto;
	outline: none;
`;

export const BaseIconModal = styled.div`
	width: 40px;
	height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 4px;
	cursor: pointer;
	background-color: ${({ theme }) => theme.grayLight};
	z-index: 10;

	svg {
		width: 20px;
		height: 20px;
		fill: ${({ theme }) => theme.grayDarker};
	}
`;

export const StyledModal = styled(Modal)`
	&.MuiModal-root {
		display: flex;
		align-items: center;
		justify-content: center;
	}
`;

export const AreaCarousel = styled.div`
	height: 100vh;
	max-height: 600px;
	width: 100%;
	max-width: 560px;
	background-color: ${({ theme }) => theme.grayDarker};
	border-radius: 8px;
	margin: 0 auto;
`;
